var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentPlaceholders',[_c('ContentPlaceholdersText',{staticClass:"title",attrs:{"lines":1}}),_c('ContentPlaceholdersText',{staticClass:"items",attrs:{"lines":3}}),_c('ContentPlaceholdersText',{staticClass:"members",attrs:{"lines":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }